// The Track 2 "live" switch (docs/frontend-v3/track2-plan.md §1). `?live=1` in the address
// = the page signs you in and the widgets wired so far read real data from app-api; without
// it the page is exactly the snapshot site it always was. Read once, at boot: a widget never
// flips source mid-session, and the normal site never loads any of the live code.

/**
 * The clean build (step 1b, docs/frontend-v3/no-snapshot.md): `VITE_SNAPSHOT=off` at build time
 * makes a site with no snapshot at all — always live, no `?live=1` needed. Only the exact word
 * "off" does it, so a typo or an unset value keeps today's snapshot site. Fixed at build time, so
 * the bundler drops every snapshot-only branch from the clean build (the CI check relies on that).
 */
export const SNAPSHOT_BUILD = import.meta.env.VITE_SNAPSHOT !== "off";

/** True only for an exact `live=1` — anything else (absent, `live=0`, `live=yes`) is off. */
export function parseLiveFlag(search: string): boolean {
  return new URLSearchParams(search).get("live") === "1";
}

/** This page's mode, fixed at load. Hooks pick their source from it once, at import —
 *  so the snapshot site runs exactly the code it always ran. (No `window` = a unit test:
 *  the snapshot mode.) The clean build is always live. */
export const LIVE = !SNAPSHOT_BUILD || (typeof window !== "undefined" && parseLiveFlag(window.location.search));
